import { render } from "./Header.vue?vue&type=template&id=a11635f2&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "@/styles/burgundy-header.css?vue&type=style&index=0&id=a11635f2&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../../../../../../private/tmp/codex-user-modern-deps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11635f2"]])

export default __exports__